<template>
    <modal :show="show.value" modal-classes="modal-xl modal-dialog-scrollable" :show-close="true" @close="closeModal">
        <template v-slot:header>
            <h5 class="modal-title" id="exampleModalLabel">Aufgaben Zeitplan</h5>
        </template>
        <task-template-form ref="tasktemplateform" :location="'/api/locations/'+location" type="small" @taskTemplateCreated="closeModal"></task-template-form>

    </modal>
</template>

<script>
    import TaskTemplateForm from "@/views/TaskTemplates/TaskTemplateForm";
    export default {
        name:"TaskTemplateModal",
        components:{TaskTemplateForm},
        props: {
            show: {
                type: Object,
                default: () => { return {value: false }}
            },
            location: {
                default: null
            },
            template: {
              default: null
            }
        },
        data() {
            return {

            }
        },
        mounted() {
          if(this.template !== null) {
            this.$refs.tasktemplateform.form.type = this.template.type;
            this.$refs.tasktemplateform.form.description = this.template.description;
            this.$refs.tasktemplateform.form.schedule = this.template.schedule;
            this.$refs.tasktemplateform.form.isPublic = this.template.isPublic;
            this.$refs.tasktemplateform.form.possibleAnswers = this.template.possibleAnswers;
            this.$refs.tasktemplateform.form.isActive = this.template.isActive;
            this.$refs.tasktemplateform.form.isAutocomplete = this.template.isAutocomplete;
            this.$refs.tasktemplateform.form.defaultAnswer = this.template.defaultAnswer;
          }

        },
      methods: {
            closeModal() {
                this.show.value = false;
                this.$emit("modalClosed");
            }
        }
    }
</script>

<style scoped>

</style>